import { reverseFormatFormDate, convertToCurrencyString, isDateEqual, isDateAfter } from '@general/js/utils';
import { findItemWithAttribute } from './SearchUtils';
import { isDateInRange, parseFormDate } from './DateTimeUtils';

export const findProductsOnGivenDate = (memberHistory, personCode, asAtDate, productTypes) => {
  if (memberHistory && personCode && asAtDate && productTypes) {
    // Get the member to search the products
    const personHistory = findItemWithAttribute(memberHistory, 'personCode', personCode);

    if (personHistory && personHistory.products) {
      const productsOnGivenDate = personHistory.products.filter((product) => {
        // Return previous products if there is any
        if (product.endDate) {
          return isDateInRange(asAtDate, parseFormDate(product.startDate), parseFormDate(product.endDate)) && productTypes.includes(product.type.toLowerCase()); // Filter with only the selected productTypes
        }
        // If product.endDate is null, it means it is the current active product
        // Check only the start date. If the start date is equal or after the as at date, return the product
        return (
          (isDateEqual(asAtDate, reverseFormatFormDate(product.startDate)) || isDateAfter(asAtDate, reverseFormatFormDate(product.startDate))) &&
          productTypes.includes(product.type.toLowerCase())
        );
      });
      return productsOnGivenDate.length > 0 ? productsOnGivenDate[0] : null;
    }
  }
  return null;
};

export const findIfProductExistsAtDateInPolicy = (memberHistory, asAtDate, productTypes) => {
  if (memberHistory && asAtDate) {
    return memberHistory.some((memberHistoryItem) => {
      return memberHistoryItem.products.some((product) => {
        if (product.endDate) {
          // const endDate = parseFormDate(product.endDate);
          return isDateInRange(asAtDate, parseFormDate(product.startDate), parseFormDate(product.endDate)) && productTypes.includes(product.type.toLowerCase()); // Filter with only the selected productTypes
        }

        return (
          (isDateEqual(asAtDate, reverseFormatFormDate(product.startDate)) || isDateAfter(asAtDate, reverseFormatFormDate(product.startDate))) &&
          productTypes.includes(product.type.toLowerCase())
        );
      });
    });
  }
  return false;
};

export const defaultValue = (value, isDate = false, isFinancial = false, isUnlimited = false, isNA = false) => {
  if (value) {
    if (isDate) {
      return reverseFormatFormDate(value);
    }

    if (isFinancial) {
      // Returns NA, applies for excess and will only show for dependents
      if (isNA) {
        return 'N/A';
      }

      if (isUnlimited) {
        return 'Unlimited';
      }
      return convertToCurrencyString(value);
    }

    return value;
  }

  // Returns NA, applies for excess and will only show for dependents
  if (isNA) {
    return 'N/A';
  }

  // Will only reach here if the value is blank, undefined or null
  if (isFinancial) {
    if (isUnlimited) {
      return 'Unlimited';
    }
    return '$0.00';
  }

  return '';
};
